import React from "react";
import {AuthorDetails, AuthorDetailsIcon, ContactDetailLink} from "./AuthorDetails";
import phoneImage from "../../../../images/icon-phone@2x.png";

export const AuthorPhone = ({authorDetails}) => {
    const {phoneNumber, active} = authorDetails;
    if (!active || !phoneNumber) return null;

    return <AuthorDetails>
        <AuthorDetailsIcon src={phoneImage}/>
        <ContactDetailLink href={"tel:" + phoneNumber} className="t-phone-number">{phoneNumber}</ContactDetailLink>
    </AuthorDetails>;
};